import { NextPageContextEnhanced } from "../../../types/page";

class MemoryCache {
  private _context: NextPageContextEnhanced;

  private cleanup() {
    const t = Date.now();
    console.time(`MemoryCacheCleaner${t}`)
    Object.keys(this._context.memoryCache).forEach((key) => {
      const { expiresAtInMS } = this._context.memoryCache[key] || {};
      if (expiresAtInMS && expiresAtInMS < Date.now()) {
        console.log(`MemoryCacheCleaner DELETE key: ${key}`);
        delete this._context.memoryCache[key];
      }
    })
    console.timeEnd(`MemoryCacheCleaner${t}`);
  }

  constructor(context: NextPageContextEnhanced) {
    this._context = context;
    setInterval(() => this.cleanup(), 60*1000); // cleanup every 1 minute all expired keys
  }

  public clear() {
    this._context.memoryCache = {};
  }

  public getAll() {
    return this._context.memoryCache;
  }

  public get(key) {
    //console.log("cache GET key:", key);
    return this._context.memoryCache[key].data;
  }

  public set(key, data, cacheTimeInSeconds) {
    console.log("cache SET key:", key);
    const expiresAtInMS = cacheTimeInSeconds * 1000 + Date.now();
    this._context.memoryCache[key] = { data, expiresAtInMS };
  }

  public hasKey(key) {
    const { expiresAtInMS, data = null } = this._context.memoryCache[key] || {};
    if (data && expiresAtInMS > Date.now()) {
      //console.log("cache EXISTS key:", key);
      return true;
    } else if (data) {
      console.log("cache DELETE key:", key);
      delete this._context.memoryCache[key];
    }
    return false;
  }
}

export default MemoryCache;
